import { fetchGet, fetchPost } from "../services/Apiservice"

/**
 * payload: { format: 'excel'|'pdf', type: 'all'|'single', order_id?: number, filters?: object }
 */
export const exportInit = (data) => {
    return fetchPost('/orders/export/init', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Build download URL from key
 */
export const exportDownloadUrl = (key) => {
    const base = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api/v1'

    return `${base}/orders/export/download/${key}`
}